/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import ScrollMenu from 'react-horizontal-scrolling-menu';
import ContentItem from '../../components/ContentItem';
import { TramRounded } from '@material-ui/icons';

class ThemeBox extends Component {
  state = {
    menuIndex: 0,
    slideIndex: 1,
    slidePlay: true,
    mouseOn: false,
    onEvent: false,
    translate: 0,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    const { themeSerial } = this.props.childProps;

    this._getContent(themeSerial);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getContent = async (themeSerial) => {
    // const { loginId } = this.props;

    const result = await this._getContentApi(themeSerial);
    const intReturn = result.data[0].intReturn;
    //const sameCode = result.data[0].sameCode;
    const contentList = result.data[0].listData;
    //console.log(contentList)
    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          contentList,
        });
      }
    }
  };
  _getContentApi = (themeSerial) => {
    const { apiUrl, loginId } = this.props;
    //console.log('/themePart?themeSerial=' + themeSerial)
    return axios
      .post(apiUrl + '/themePart', {
        params: {
          themeSerial: themeSerial,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };

  _renderItem = () => {
    const { contentList } = this.state;

    const list = contentList.map((item, index) => {
      return (
        <div key={index}>
          <ContentItem
            refer={'sametime'}
            contentSerial={item.contentSerial}
            title={item.title}
            genreName={item.genreName}
            img={item.img}
            overImg={item.overImg}
            restrictionCode={item.restrictionCode}
            opening={item.opening}
            director={item.director}
            contentSysnopsis={item.contentSysnopsis}
            wishFlag={item.wishFlag}
            contentPartSerial={item.contentPartSerial}
            num={index + 1}
            onEndItemSlide={this._onEndItemSlide}
            subTitle={item.subTitle}
          />
        </div>
      );
    });

    return list;
  };
  _onEndItemSlide = (num, over) => {
    const { slideIndex } = this.state;
    let scrollPos;
    ////console.log(slideIndex)
    if (num === null || num === '' || num === undefined) {
    } else {
      //console.log(over, num, slideIndex)
      if (over) {
        if (num % 6 === 0) {
          if (slideIndex === 1) {
            scrollPos = 1;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 2) {
            scrollPos = 7;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 3) {
            scrollPos = 13;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 4) {
            scrollPos = 19;
            this.scrollMenu.scrollTo(scrollPos.toString());
          }
        }
      } else {
        if (num % 6 === 0) {
          if (slideIndex === 1) {
            scrollPos = 0;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 2) {
            scrollPos = 6;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 3) {
            scrollPos = 12;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 4) {
            scrollPos = 18;
            this.scrollMenu.scrollTo(scrollPos.toString());
          }
        }
      }
    }
  };

  _onToggleMouseOn = () => {
    // const { mouseOn, slideIndex, contentList } = this.state;

    this.setState({
      mouseOn: true,
    });

    /*
        this.setState({
            translate: -500
        })
        */
    ////console.log('===>')
    ////console.log(this.scrollMenu)
    //this.scrollMenu.scrollTo(10)
    ////console.log(slideIndex)
    ////console.log(parseInt(contentList.length/6))
  };
  _onToggleMouseOff = () => {
    //const { mouseOn } = this.state;

    this.setState({
      mouseOn: false,
    });
  };
  _onSelect = (key) => {
    ////console.log(key)
    ////console.log(0)
    //const a = 10
    //this.scrollMenu.scrollTo(a.toString())
  };
  _arrowNext = () => {
    const { slideIndex, contentList } = this.state;
    const cnt = contentList.length;
    const page = Math.round(cnt / 6);

    if (slideIndex < page) {
      this.setState({
        slideIndex: slideIndex + 1,
      });
    }
  };
  _arrowPrev = () => {
    const { slideIndex } = this.state;
    // const cnt = contentList.length;
    // const page = Math.round(cnt / 6);

    //if(slideIndex <= 1) {
    this.setState({
      slideIndex: slideIndex - 1,
    });
    //}
  };
  _renderDot = () => {
    const { slideIndex, contentList } = this.state;
    const cnt = parseInt(contentList.length);

    let page = Math.round(cnt / 6);
    if (page === 0) {
      page = 1;
    }

    let arr = [];

    for (let i = 1; i <= page; i++) {
      arr.push(<em key={i} className={i === slideIndex ? 'on' : null}></em>);
    }
    const list = arr.map((item) => {
      return item;
    });
    ////console.log()
    return list;
  };
  _onUpdate = (translate) => {
    ////console.log(translate)
  };
  _onMore = () => {
    //const { sameCode } = this.state;
    const { history } = this.props;
    history.push('/theme');

    // const { themeSerial } = this.props.childProps;

    //history.push('/list?q=same&c='+ sameCode)
    //history.push('/tlist?ts='+ themeSerial)
  };
  _goTheme = () => {
    const { themeSerial } = this.props.childProps;
    const { history } = this.props;
    history.push('/tlist?ts=' + themeSerial);
  };
  render() {
    const { contentList, mouseOn, slideIndex } = this.state;
    const { title, imageS } = this.props.childProps;

    return (
      <Fragment>
        {contentList ? (
          <div className="main_list_style m_randomlist m_thumblist ">
            <h1>
              <strong
                style={{ cursor: 'pointer', height: 90, lineHeight: 4 }}
                onClick={this._goTheme}
              >
                <img
                  src={
                    'https://bc8azosk4j.ecn.cdn.ofs.kr/aniplustv/theme/' +
                    imageS
                  }
                />{' '}
                {title}
              </strong>

              <div>
                {/*this._renderDot()*/}
                <a style={{ cursor: 'pointer' }} onClick={this._onMore}>
                  전체 테마 보기
                </a>
              </div>
            </h1>

            <div
              className="main_list_goup1"
              onMouseEnter={this._onToggleMouseOn}
              onMouseLeave={this._onToggleMouseOff}
            >
              {/*
                        <a href="#" className="left_btn"><span>이전</span></a>
                        <a href="#" className="right_btn"><span className="on">다음</span></a>
                        */}
              {/*리스트 오브 시 좌우 버튼 생김*/}
              <div className="div_ul">
                {/*
                        <Slider ref={(ref) => (this.slider = ref)} {...settings} >
                    
                            { contentList ? this._renderItem() : null}
                        
                        </Slider>
                        */}

                <ScrollMenu
                  data={contentList ? this._renderItem() : null}
                  arrowLeft={
                    mouseOn ? (
                      slideIndex === 1 ? null : (
                        <a
                          className="left_btn"
                          style={{ cursor: 'pointer' }}
                          onClick={this._arrowPrev}
                        >
                          <span className={'on'}>이전</span>
                        </a>
                      )
                    ) : null
                  }
                  arrowRight={
                    mouseOn ? (
                      slideIndex > parseInt(contentList.length / 6) ? null : (
                        <a
                          className="right_btn"
                          style={{ cursor: 'pointer' }}
                          onClick={this._arrowNext}
                        >
                          <span className={'on'}>다음</span>
                        </a>
                      )
                    ) : null
                  }
                  wheel={false}
                  dragging={TramRounded}
                  //transition={0.5}
                  //translate={0}
                  alignOnResize={true}
                  //inertiaScrolling={true}
                  //inertiaScrollingSlowdown={3}
                  //wrapperStyle={{border: 0, backgroundColor: '#000'}}
                  itemStyle={{ verticalAlign: 'text-top' }}
                  alignCenter={false}
                  hideSingleArrow={true}
                  hideArrows={mouseOn}
                  onUpdate={this._onUpdate}
                  ref={(ref) => (this.scrollMenu = ref)}
                  //innerWrapperStyle={{textAlign: 'center'}}
                  onSelect={this._onSelect}
                  rtl={false}
                  scrollBy={6}
                  //selected={selected}
                />
              </div>
              <div className="clear"></div>
            </div>
          </div>
        ) : null}
        {/*
                <div>
                    { contentList ? this._renderItem() : null }
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ThemeBox));
